<span [style.color]="_color">{{
    (published ? _i18n._9113_PUBLISHED : _i18n._9476_DRAFT) | translate
}}</span>
